import React, { Component } from 'react';
import config from './../store/index.js';
import init from './../navigation.js';

class Header extends Component {
	componentWillMount() {
		// presumably temp fix to avoid initializing header on landing page
		if (!config.page || (config.page && config.page !== 'landing')) {
			init();
		}
	}

	render() {
		return (
			<div id="header" />
		);
	}
}

export default Header;



// WEBPACK FOOTER //
// ./mobile-core/src/components/header.js